import React from "react";
import { useTranslation } from "react-i18next";
import storageMonitor from "assets/img/storageMonitor.png";

const Step1 = React.forwardRef((props, ref) => {
  const { t } = useTranslation('wizard');
  const isValidated = () => {
      return true;
  };
  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return isValidated();
    },
  }));
  return (
    <>
      <div className="info-text c-white">
        {t('storages.step1Body')}
      </div>
      <div className="text-center">
        <img src={storageMonitor} alt="storage-monitor" />
      </div>
    </>
  );
});

export default Step1;
